import MainResults from './components/MainResults.vue';
import SearchForm from './components/SearchForm.vue';
import SearchResults from './components/SearchResults.vue';
import StraightResult from './components/StraightResult';
import analytics from './tools/ga';
import Vue from 'vue';
require("../js/experiment/experimentLoader")
import {expBus} from "@js-packages/experiment-loader";

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const app = new Vue({
  el: '#app',
  components: {
    SearchResults,
    StraightResult,
    MainResults,
    SearchForm,
  },
  data() {
    return {
      getSignedRequestBody: null
    }
  },
  async beforeMount() {
    try {
      this.getSignedRequestBody = await (
        await import(
          /* webpackChunkName: "link.chunk" */
          './tools/getSignedRequestBody.js'
          )
      ).default
    } catch (error) {
      this.getSignedRequestBody = async (requestData) => {
        return typeof requestData === 'string' ? { sf_url: requestData } : requestData;
      }
    }
  },
  mounted() {
    this.$on('link-insert', (link) => {
      analytics.linkInsert(link);
    });
    this.$on('link-submit', (link) => {
      analytics.linkSubmit(link);
    });
    this.$on('link-submit-posts', (link) => {
      analytics.linkSubmit(link);
    });
    this.$on('link-submit-stories', (link) => {
      analytics.linkSubmit(link);
    });
    this.$on('straight-submit', (link) => {
      analytics.linkSubmit(link);
    });
    this.$on('link-cast', (link) => {
      analytics.linkInsert(link);
    });
    this.$on('search-request', (keyword) => {
      if (keyword !== null) {
        analytics.keywordSubmit(keyword);
      }
    });
    this.$on('new-request', () => {
      expBus.emit('clickAds')
    });
    this.$on('keyword-insert', (keyword) => {
      analytics.keywordInsert(keyword);
    });
    this.$on('search-download', (link) => {
      analytics.searchDownload(link);
    });
    this.$on('download-click', (link, format) => {
      expBus.emit('clickAds')
      analytics.downloadClick(link, format);
    });
    this.$on('show-results', (result, link) => {
      analytics.showResults(link);
    });
    this.$on('show-error', (e, link) => {
      analytics.showError(e);
    });
  },
  methods: {
    async subscribeSignedRequestBody(url) {
      return await this.getSignedRequestBody(
        url
      )
    },
  }
});
